import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Image,
  Row,
  Col,
  Offcanvas,
  Dropdown,
  Collapse,
  Spinner,
} from "react-bootstrap";
import {
  FaUser,
  FaGooglePlay,
  FaApple,
  FaFileAlt,
  FaSearch,
  FaWallet,
} from "react-icons/fa";
import { CgMenuRight } from "react-icons/cg";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo1.svg";
import Authentication from "../Authentication/Authentication";
import { getAuthDetails, playStoreUrl } from "../../../constants/helpers";
import { clearSpecificLocalStorage } from "../../../constants/localStorage";
import UserSelectionModal from "../../../components/UserSelectionModal";
import { MdOutlineArrowDropDown } from "react-icons/md";
import LocationSelector from "../../../components/LocationSelector";
import AppComingSoonModal from "../../../components/AppComingSoonModal";
import { useGetWalletHistoryQuery } from "../../../redux/api/Wallet/WalletApi";

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const [show, setShow] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showUserModel, setShowUserModel] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, mobileNumber } = getAuthDetails();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [navigationPath, setNavigationPath] = useState("");
  const isMobile = window.innerWidth < 576;

  // Fetch wallet data
  const { data: walletData, isLoading: walletLoading } =
    useGetWalletHistoryQuery(
      { phoneNumber: mobileNumber },
      { skip: !isAuthenticated || !mobileNumber },
    );

  const remainingPoints = walletData?.total_points?.remaining_points || 0;

  const openModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleLogout = () => {
    clearSpecificLocalStorage(["authToken", "mobileNumber"]);
    window.location.href = "/";
  };

  const handleProfileClick = () => {
    navigate("/profile");
    setShow(false);
  };

  const handlePointsClick = () => {
    navigate("/profile", { state: { openPointsTab: true } });
    setShow(false);
  };

  const handleUserSelect = (user) => {
    setShowUserModel(false);
    navigate(navigationPath, { state: { user } });
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleSearchClick = () => {
    navigate("/search");
    setShow(false);
  };

  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
    setShow(false);
  };

  const handleNavigation = (path) => {
    const userSelectionRoutes = ["/bookings", "/prescription", "/reports"];

    if (userSelectionRoutes.includes(path)) {
      if (!isAuthenticated) {
        navigate("/login");
      } else {
        setNavigationPath(path);
        setShowUserModel(true);
      }
    } else {
      navigate(path);
      setShow(false);
    }
  };

  // Services query removed as we don't need dropdown data anymore

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Bookings", path: "/bookings" },
    { label: "Upload Prescription", path: "/prescription" },
    { label: "Package Test", path: "/all-package-tests" },
    { label: "Individual Test", path: "/all-Individual-tests" },
    { label: "About Us", path: "/about-us" },
    { label: "Contact Us", path: "/contact-us" },
  ];

  const renderNavLinks = (mobile = false) => {
    return navLinks.map((link) => {
      if (link.children && link.children.length > 0) {
        if (mobile) {
           const isOpen = openSections[link.label];
           return (
             <React.Fragment key={link.label}>
               <div 
                 className="py-2 fw-bold text-dark d-flex justify-content-between align-items-center" 
                 onClick={() => setOpenSections(prev => ({ ...prev, [link.label]: !isOpen }))}
               >
                  {link.label} <MdOutlineArrowDropDown style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: '0.3s' }} />
               </div>
               <Collapse in={isOpen}>
                  <div className="ps-3 border-start ms-2">
                    {link.children.map(child => (
                      <Nav.Link
                        key={child.path}
                        className="py-1 text-muted small"
                        onClick={() => handleNavigation(child.path)}
                      >
                        {child.label}
                      </Nav.Link>
                    ))}
                  </div>
               </Collapse>
             </React.Fragment>
           );
        }
        return (
          <Dropdown key={link.label} className="nav-item-dropdown">
            <Dropdown.Toggle
              as={Nav.Link}
              className={`mx-2 fw-bold text-dark nav-link-custom ${
                location.pathname.startsWith(link.path) ? "active" : ""
              }`}
            >
              {link.label} <MdOutlineArrowDropDown />
            </Dropdown.Toggle>
            <Dropdown.Menu className="border-0 shadow-sm rounded-3 mt-0">
              {link.children.map(child => (
                <Dropdown.Item 
                  key={child.path} 
                  onClick={() => handleNavigation(child.path)}
                  className="py-2 px-3 small border-bottom last-child-border-0"
                >
                  {child.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        );
      }

      return (
        <Nav.Link
          key={link.path}
          className={`${
            mobile ? "py-2" : "mx-2"
          } fw-bold text-dark nav-link-custom ${
            isActive(link.path) ? "active" : ""
          }`}
          style={{
            fontSize: mobile ? "14px" : "14px",
            position: "relative",
            transition: "color 0.3s ease",
          }}
          onClick={() => handleNavigation(link.path)}
        >
          {link.label}
        </Nav.Link>
      );
    });
  };

  const renderDesktopNavigation = () => {
    return (
      <Navbar bg="light" className="py-2 border-0 d-none d-lg-block">
        <Container className="mt-3">
          <Nav>{renderNavLinks()}</Nav>
          <Nav className="ms-auto">
            <button
              className={`bg-purple mx-2 fw-bold text-white btn`}
              style={{
                fontSize: "12px",
                position: "relative",
                transition: "color 0.3s ease",
                display: "flex",
                alignItems: "center",
                background: "none",
                border: "none",
                padding: "0.5rem 0.75rem",
              }}
              onClick={handleSearchClick}
            >
              <FaSearch className="me-2" />
              Search
            </button>
            <button
              className={`bg-purple mx-2 fw-bold text-white btn`}
              style={{
                fontSize: "12px",
                position: "relative",
                transition: "color 0.3s ease",
                display: "flex",
                alignItems: "center",
                background: "none",
                border: "none",
                padding: "0.5rem 0.75rem",
              }}
              onClick={() => handleNavigation("/reports")}
            >
              <FaFileAlt className="me-2" />
              Reports
            </button>
          </Nav>
        </Container>
      </Navbar>
    );
  };

  const renderMobileNavLinks = () => {
    return (
      <>
        {renderNavLinks(true)}
        <button
          className={`bg-purple py-2 fw-bold text-white btn mb-2`}
          style={{
            fontSize: "14px",
            position: "relative",
            transition: "color 0.3s ease",
            background: "none",
            border: "none",
            outline: "none",
          }}
          onClick={handleSearchClick}
        >
          <FaSearch className="me-2" />
          Search
        </button>
        <button
          className={`bg-purple py-2 fw-bold text-white btn`}
          style={{
            fontSize: "14px",
            position: "relative",
            transition: "color 0.3s ease",
            background: "none",
            border: "none",
            outline: "none",
          }}
          onClick={() => handleNavigation("/reports")}
        >
          <FaFileAlt className="me-2" />
          Reports
        </button>
      </>
    );
  };

  const renderDesktopProfileButton = () => {
    return (
      <>
        {isAuthenticated ? (
          <>
            {/* Points Indicator */}
            <button
              className="border-0 d-flex align-items-center me-3 bg-light"
              onClick={handlePointsClick}
              style={{ cursor: "pointer" }}
            >
              <FaWallet
                className={`me-2 ${
                  remainingPoints < 0 ? "text-danger" : "text-success"
                }`}
                size={16}
              />
              <span
                className="fw-semibold text-purple"
                style={{ fontSize: "15px" }}
              >
                {walletLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <span
                    className={
                      remainingPoints < 0 ? "text-danger" : "text-success"
                    }
                  >
                    {remainingPoints}
                  </span>
                )}
              </span>
            </button>

            {/* Profile Dropdown */}
            <Dropdown>
              <Dropdown.Toggle
                className="border-0 d-flex align-items-center me-3 bg-transparent"
                id="profile-dropdown"
              >
                <FaUser className="me-2 text-purple" fontSize={17} />
                <span
                  className="fw-semibold text-purple"
                  style={{ fontSize: "15px" }}
                >
                  My Profile <MdOutlineArrowDropDown />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleProfileClick}>View</Dropdown.Item>
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </>
        ) : (
          <button
            className="border-0 d-flex align-items-center me-3 bg-light"
            onClick={() => navigate("/login")}
          >
            <FaUser className="me-2 text-purple" fontSize={17} />
            <span
              className="fw-semibold text-purple"
              style={{ fontSize: "15px" }}
            >
              Login
            </span>
          </button>
        )}
      </>
    );
  };

  const renderMobileProfileButton = () => {
    return (
      <div className="d-flex flex-column gap-2">
        {isAuthenticated ? (
          <div className="w-100">
            <button
              onClick={() => setOpen(!open)}
              className="w-100 py-2 px-4 d-flex align-items-center justify-content-center btn-outline-purple"
              aria-controls="profile-collapse"
              aria-expanded={open}
            >
              <FaUser className="me-2" />
              <span>My Profile</span>
            </button>
            <Collapse in={open}>
              <div
                id="profile-collapse"
                className="border-start border-end border-bottom rounded-bottom"
              >
                <div className="w-100 d-flex flex-column">
                  <Button
                    variant="link"
                    className="text-decoration-none d-flex align-items-center justify-content-center text-dark py-2 text-start ps-3"
                    onClick={handlePointsClick}
                  >
                    My Points
                    <span className="ms-auto d-flex align-items-center">
                      <FaWallet
                        className={`me-2 ${
                          remainingPoints < 0 ? "text-danger" : "text-success"
                        }`}
                        size={16}
                      />
                      {walletLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <span
                          className={
                            remainingPoints < 0 ? "text-danger" : "text-success"
                          }
                        >
                          {remainingPoints}
                        </span>
                      )}
                    </span>
                  </Button>
                  <Button
                    variant="link"
                    className="text-decoration-none text-dark py-2 text-start ps-3"
                    onClick={handleProfileClick}
                  >
                    Profile
                  </Button>
                  <Button
                    variant="link"
                    className="text-decoration-none text-dark py-2 text-start ps-3"
                    onClick={handleLogout}
                  >
                    Logout
                  </Button>
                </div>
              </div>
            </Collapse>
          </div>
        ) : (
          <button
            className="w-100 py-2 d-flex align-items-center justify-content-center btn-outline-purple"
            onClick={() => {
              navigate("/login");
              setShow(false);
            }}
          >
            <FaUser className="me-2" />
            <span className="fw-semibold">Login</span>
          </button>
        )}
      </div>
    );
  };

  const logoStyle = {
    width: "140px",
    height: "auto",
  };

  const mobileLogoStyle = {
    width: "100px",
    height: "auto",
  };

  return (
    <>
      <div className="sticky-top" style={{ zIndex: 1020 }}>
        <Navbar bg="white" className="py-1 border-bottom">
          <Container>
            <Navbar.Brand
              className="me-0 me-lg-4"
              onClick={handleLogoClick}
              style={{ cursor: "pointer" }}
            >
              <Image
                src={logo}
                style={isMobile ? mobileLogoStyle : logoStyle}
                className="d-inline-block align-top"
                alt="Diagnostic Center"
              />
            </Navbar.Brand>

            <div className="d-none d-lg-flex align-items-center ms-auto">
              <LocationSelector />
              {renderDesktopProfileButton()}
              <button
                className="d-lg-none btn-purple p-2 me-2"
                onClick={handleSearchClick}
              >
                <FaSearch size={20} />
              </button>
              <div className="d-flex align-items-center">
                <button
                  style={{ borderRadius: "5px" }}
                  size="sm"
                  className="me-2 d-flex align-items-center p-2 btn-purple"
                  onClick={() => window.open(playStoreUrl, "_blank")}
                >
                  <FaGooglePlay />
                </button>
                <button
                  style={{ borderRadius: "5px" }}
                  size="sm"
                  className="d-flex align-items-center p-2 btn-purple"
                  onClick={openModal}
                >
                  <FaApple />
                </button>
              </div>
            </div>
            <button
              className="btn-purple d-lg-none p-2 me-2"
              onClick={handleSearchClick}
              aria-label="Search"
            >
              <FaSearch size={isMobile ? 18 : 20} />
            </button>
            <button
              className="d-lg-none btn-purple p-2"
              onClick={handleShow}
              aria-label="Open menu"
            >
              <CgMenuRight size={isMobile ? 18 : 25} />
            </button>
          </Container>
        </Navbar>
        {renderDesktopNavigation()}
      </div>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="offcanvas-menu"
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <Image
              src={logo}
              height="30"
              className="d-inline-block align-top"
              alt="Diagnostic Center"
            />
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="d-flex flex-column">
          <div className="mb-4">{renderMobileProfileButton()}</div>

          <div className="navigation-section mb-4">
            <h6 className="text-secondary mb-2">MENU</h6>
            <Nav className="flex-column gap-1">
              {renderMobileNavLinks(true)}
            </Nav>
          </div>

          <div className="mt-auto">
            <h6 className="text-secondary text-center mb-2">
              Download Our App
            </h6>
            <Row className="g-2">
              <Col xs={6}>
                <button
                  className="w-100 p-2 btn-outline-purple"
                  onClick={() => window.open(playStoreUrl, "_blank")}
                >
                  <FaGooglePlay className="me-2" />
                  Play Store
                </button>
              </Col>
              <Col xs={6}>
                <button
                  className="w-100 p-2 btn-outline-purple"
                  onClick={openModal}
                >
                  <FaApple className="me-2" />
                  App Store
                </button>
              </Col>
            </Row>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* {showAuthModal && (
        <Authentication onClose={() => setShowAuthModal(false)} />
      )} */}
      <UserSelectionModal
        show={showUserModel}
        onHide={() => {
          setShowUserModel(false);
          setShow(false);
        }}
        onUserSelect={handleUserSelect}
      />
      <AppComingSoonModal
        show={showModal}
        onHide={closeModal}
        title="Coming Soon!"
        body="This app is not yet available in the stores. Please check back later."
        buttonText="Got it"
        buttonVariant="primary"
      />
    </>
  );
};

export default Header;
